import React from 'react';
import { Flex, Typography, Select, theme } from 'antd';
import { GlassCard } from '../../../../shared/components';
import { ProductOutlined } from '@ant-design/icons';
import { useTranslate } from '@refinedev/core';

const { Title } = Typography;

interface OrderProductsProps {
    selectedProducts: string[];
    productOptions: any[];
    isAdmin: boolean;
    onProductChange: (values: string[]) => void;
}

const CardTitle = ({ title, bg = 'bg-white' }: { title: string; bg?: string }) => {
    const { token } = theme.useToken();
    return (
        <Flex justify="left" align="center" className="mb-4">
            <div className={`text-center px-4 text-base font-semibold`} style={{ color: token.colorText }}>
                {title}
            </div>
        </Flex>
    );
};

export const OrderProducts: React.FC<OrderProductsProps> = ({
    selectedProducts,
    productOptions,
    isAdmin,
    onProductChange
}) => {
    const _t = useTranslate();
    const { token } = theme.useToken();

    return (
        <GlassCard className="shadow-lg">
            <CardTitle title={_t("orders.fields.products")} />
            <div className="space-y-4">
                <div className="flex items-center space-x-3 p-2 rounded-lg border" style={{ borderColor: token.colorPrimary }}>
                    <div className="flex-1 min-w-0">
                        <Select
                            placeholder={_t('orders.titles.selectProducts')}
                            className="w-full"
                            mode="multiple"
                            allowClear
                            onChange={onProductChange}
                            options={productOptions}
                            value={selectedProducts}
                            disabled={!isAdmin}
                            size="middle"
                        />
                    </div>
                </div>
            </div>
        </GlassCard>
    );
}; 